// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.111.1/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".verify-account-shell-4095ik3Cmwr{max-width:360px}.verify-account-logo-427lGlJOmwr{height:40px}", "",{"version":3,"sources":["webpack://./client/login/verify-account.scss"],"names":[],"mappings":"AAAA,kCACE,eAAA,CAGF,iCACE,WAAA","sourcesContent":[".shell {\n  max-width: 360px;\n}\n\n.logo {\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shell": "verify-account-shell-4095ik3Cmwr",
	"logo": "verify-account-logo-427lGlJOmwr"
};
export default ___CSS_LOADER_EXPORT___;
